import { ArrowRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Picture } from './picture'
import { SectionEyebrow } from './section-eyebrow'

export function AboutSection() {
  const { t } = useTranslation()

  return (
    <section id="about" className="bg-surface py-section">
      <div className="max-w-content px-margin-mobile md:px-margin-tablet lg:px-margin-desktop mx-auto">
        <div className="gap-stack-lg md:gap-gutter grid items-center md:grid-cols-2">
          <div className="gap-stack-md flex flex-col">
            <SectionEyebrow>{t('about.eyebrow')}</SectionEyebrow>

            <h2 className="font-display text-headline-lg text-primary">{t('about.heading')}</h2>

            <p className="text-body-md text-on-surface-variant">{t('about.body1')}</p>
            <p className="text-body-md text-on-surface-variant">{t('about.body2')}</p>

            <a
              href="#contact"
              className="group text-label-md text-secondary inline-flex w-fit items-center gap-2 rounded-sm font-medium hover:underline"
            >
              {t('about.link')}
              <ArrowRight
                className="size-4 transition-transform duration-200 group-hover:translate-x-1 motion-reduce:transition-none motion-reduce:group-hover:translate-x-0"
                aria-hidden
              />
            </a>
          </div>

          <div className="border-outline-variant shadow-e1 overflow-hidden rounded-lg border">
            <Picture
              name="about-facility"
              alt={t('about.imageAlt')}
              sizes="(min-width: 768px) 50vw, 100vw"
              className="aspect-[4/3] size-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  )
}
